import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { mq } from '@/ui-kit/theme';

const StyledTitle = styled.div(() => {
  return {
    fontFamily: 'Work Sans, sans-serif',
    textAlign: 'center',
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '130%',

    [mq.xs]: { fontSize: '18px' },
  };
});

interface ITitleProps extends PropsWithChildren {
  className?: string;
}

export const Title = ({
  className,
  children,
}: ITitleProps) => {
  return (
    <StyledTitle className={className}>{children}</StyledTitle>
  );
};
